import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

import styles from './UspPageTitle.module.scss'

const BackButtonWithLinkUrl = ({ backLink }) => {
  return (
    <Link href={backLink}>
      <a className={styles.backLink}>
        <img src="/images/back_arrow.svg" alt="<" />
      </a>
    </Link>
  )
}

const BackButton = () => {
  const router = useRouter()
  const handleBackButtonClick = () => {
    router.back()
  }
  return (
    <a className={styles.backLink} href="#" onClick={handleBackButtonClick}>
      <img src="/images/back_arrow.svg" alt="go back" />
    </a>
  )
}

/**
 * This component shows the page header nav bar with a header,
 * back button and a helper back text if required
 * @param title : Header for the navbar.
 * @param backlink : Specific url to navigate to.
 * @param backButton : Boolean to show back button that goes back in user's navigation history. `backlink` takes precendence if set.
 * @param navigationHelperText : Helper text to show next to the back button.
 * @param className : Extra css classes to applied to the container.
 *
 * @returns
 */
const UspPageTitle = ({
  title,
  backLink = '',
  backButton = false,
  navigationHelperText = '',
  className,
  forceShowBackButton = false
}) => {
  let backButtonNode = null
  const [showBackButton, setShowBackButton] = useState(false)
  let backButtonHelperTextNode = null
  const kp4Url = publicRuntimeConfig.kp4BaseUrl + '/'

  useEffect(() => {
    if (forceShowBackButton) {
      setShowBackButton(true)
    } else {
      if (window.history.length > 1) {
        if (
          window.sessionStorage.getItem('origin') === window.location.href ||
          ![kp4Url, window.location.hostname].includes(document.referrer)
        ) {
          setShowBackButton(false)
        } else {
          setShowBackButton(true)
        }
      } else {
        window.sessionStorage.setItem('origin', window.location.href)
      }
    }
  }, [])

  if (backLink) {
    backButtonNode = <BackButtonWithLinkUrl backLink={backLink} />
  }

  if (backButton && !backLink) {
    backButtonNode = <BackButton />
  }

  if (navigationHelperText) {
    backButtonHelperTextNode = (
      <span className={styles.backLinkHelperText}>{navigationHelperText}</span>
    )
  }

  return (
    <div className={classNames(styles.uspPageTitleContainer, className)}>
      <div className={classNames(styles.uspPageBackButtonContainer)}>
        {showBackButton && backButtonNode}
        {showBackButton && backButtonHelperTextNode}
      </div>
      <h6 className={classNames(styles.uspPageTitle)}>{title}</h6>
    </div>
  )
}

export default UspPageTitle
